import React from 'react';

// InventoryOS's own mark — a crate/package outline (visible top-seam + center seam), reads as
// "goods in storage" rather than a generic chat bubble. currentColor throughout so it inherits
// whatever color context it's dropped into (navbar logo tile, login header, etc).
const BrandMark = (props) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 2.5 L20.5 7 V17 L12 21.5 L3.5 17 V7 Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M3.5 7 L12 11.25 L20.5 7" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    <path d="M12 11.25 V21.5" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export default BrandMark;
